import { DateTime } from 'luxon';
import { ContentArticle } from './types';
import { Link } from 'react-router-dom';
import { Avatar, AvatarImage } from '@playcastdotio/Shadcn';

interface ArticleCardProps {
  article: ContentArticle;
}

export const ArticleCard = (props: ArticleCardProps) => {
  const { article } = props;

  return (
    <article
      key={article.slug}
      className='bg-content col-span-12 flex grow flex-col flex-wrap content-start gap-y-2 rounded-lg shadow-md md:col-span-4 lg:gap-y-4'
    >
      <Link to={article.slug} className='flex h-full flex-col'>
        <img
          src={article.banner}
          alt='Playcast reduces latency for interactive game streaming'
          className='aspect-[2/1] h-auto w-full rounded-t-lg object-cover md:aspect-[3/2]'
        />
        <div className='flex grow flex-col items-start gap-2 px-8 py-6 lg:gap-4'>
          <p className='text-sm'>
            <time dateTime={article.published}>{DateTime.fromISO(article.published).toFormat('dd LLL yyyy')}</time>
          </p>
          <h3 className='text-lg font-bold lg:text-xl'>{article.title}</h3>
          <p className='line-clamp-6'>{article.summary}</p>
          <div className='grow'></div>
          <div className='flex items-center gap-2'>
            <Avatar className='h-12 w-12'>
              <AvatarImage src={article.author.headshot} alt={article.author.name} />
            </Avatar>
            <div className='ml-2'>
              <p className='text-lg font-bold'>{article.author.name}</p>
              <p className='-mt-1 italic'>{article.author.title}</p>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};

